<template>
  <div class="modal_dim on">
    <!--'on 추가'-->
    <div class="modal_wrap">
      <div class="modal_inner center w1200">
        <div class="modal w80p">
          <div class="modal_con">
            <div class="print_wrap">
              <div class="print">
                <div class="table">
                  <div class="row fix120">
                    <div class="cell"><p class="print_ttl">{{ data.applyType === 1 ? '교육' : '시험' }} 수강증</p></div>
                  </div>
                  <div class="row fix70">
                    <div class="cell fix150"><p>{{ data.applyType === 1 ? '교 육 ' : '시 험 ' }} 명</p></div>
                    <div class="cell">
                      <p class="left">
                        <span style="font-size: 20rem;font-weight: bold;" v-if="data.applyType === 1">
                          {{ data.item.edu.title }}
                        </span>
                        <span style="font-size: 20rem;font-weight: bold;" v-else>
                          {{ data.item.exam.examinationName }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="row fix70">
                    <div class="cell fix150"><p>종 목 명</p></div>
                    <div class="cell"><p class="left">외식경영관리사</p></div>
                    <div class="cell fix150"><p>교육구분</p></div>
                    <div class="cell">
                      <p class="left" v-if="data.applyType === 1">{{ data.item.edu.rating }}급</p>
                    <p class="left" v-else>{{ data.item.exam.rating }}급 {{ data.item.exam.part }}</p>
                    </div>
                  </div>
                  <div class="row fix70">
                    <div class="cell fix150"><p>성&emsp;&nbsp;명</p></div>
                    <div class="cell">
                      <p v-if="data.applyType === 1">{{ data.item.userEdu.name }}</p>
                      <p v-else>{{ data.item.userExam.koName }}</p>
                    </div>
                    <div class="cell fix150"><p>생년월일</p></div>
                    <div class="cell">
                      <p v-if="data.applyType === 1">
                        {{ dateFormat(data.item.userEdu.userBirth) }}
                      </p>
                      <p v-else>
                        {{ dateFormat(data.item.userExam.userBirth) }}
                      </p>
                    </div>
                  </div>
                  <div class="row fix100">
                    <div class="cell fix150"><p>주&emsp;&nbsp;소</p></div>
                    <div class="cell">
                      <p class="left" v-if="data.applyType === 1">우편번호:  {{ data.item.userEdu.postCode }}<br />
                        {{ data.item.userEdu.userAddress }} {{ data.item.userEdu.userAddress2 }}<br />
                      </p>
                      <p class="left" v-else>우편번호: {{ data.item.userExam.postCode }} <br />
                      {{ data.item.userExam.userAddr }} {{ data.item.userExam.userAddr2 }}<br />
                      </p>
                    </div>
                  </div>
                  <div class="row fix100">
                    <div class="cell fix150">
                      <p>일시 및<br />장소</p>
                    </div>
                    <div class="cell">
                      <p class="left" v-if="data.applyType === 1">
                        <span style="color: blue;"
                        >○ 일 시:
                          {{ dateFormat(data.item.edu.eduDate) }}({{ getDate(data.item.edu.eduDate) }})
                          {{ data.item.edu.time }}까지
                          입실완료</span
                        ><br />
                        ○ 장 소: {{ data.item.edu.address }} {{ data.item.edu.address2 }}
                      </p>
                      <p class="left" v-else>
                        <span style="color: blue;"
                          >○ 일 시:
                          {{ dateFormat(data.item.exam.examDate) }}({{ getDate(data.item.exam.examDate) }})
                          {{ data.item.exam.time }}까지
                          입실완료</span
                        ><br />
                        ○ 장 소: {{ data.item.exam.address }} {{ data.item.exam.address2 }}
                      </p>
                    </div>
                  </div>
                  <div class="row fix100">
                    <div class="cell fix150">
                      <p>수강료<br />환불안내</p>
                    </div>
                    <div class="cell">
                      <p class="left" v-if="data.applyType === 1">
                        {{ dateFormat(data.item.edu.reStartDate) }} ({{ getDate(data.item.edu.reStartDate) }}) 00:00 ~
                        {{ dateFormat(data.item.edu.reEndDate) }} ({{ getDate(data.item.edu.reEndDate) }})
                        23:59 [{{ data.item.edu.percent }}% 환불]<br />
                        {{ dateFormat(data.item.edu.reStartDate2) }} ({{ getDate(data.item.edu.reStartDate2) }}) 00:00 ~
                        {{ dateFormat(data.item.edu.reEndDate2) }} ({{ getDate(data.item.edu.reEndDate2) }})
                        23:59 [ {{ data.item.edu.percent2 }}% 환불]<br />
                        <span style="color: #FF9F00;font-size: 15rem;"
                        >※ 환불기간 이후에는 수강료 환불이 불가합니다.</span
                        >
                      </p>
                      <p class="left" v-else>
                        {{ dateFormat(data.item.exam.reStartDate) }} ({{ getDate(data.item.exam.reStartDate) }}) 00:00 ~
                        {{ dateFormat(data.item.exam.reEndDate) }} ({{ getDate(data.item.exam.reEndDate) }})
                        23:59 [{{ data.item.exam.percent }}% 환불]<br />
                        {{ dateFormat(data.item.exam.reStartDate2) }} ({{ getDate(data.item.exam.reStartDate2) }}) 00:00 ~
                        {{ dateFormat(data.item.exam.reEndDate2) }} ({{ getDate(data.item.exam.reEndDate2) }})
                        23:59 [ {{ data.item.exam.percent2 }}% 환불]<br />
                        <span style="color: #FF9F00;font-size: 15rem;"
                          >※ 환불기간 이후에는 수강료 환불이 불가합니다.</span
                        >
                      </p>
                    </div>
                  </div>
                  <div class="row fix70">
                    <div class="cell"><p>기타사항</p></div>
                  </div>
                  <div class="row">
                    <div class="cell">
                      <p class="left">
                        ◎ 장애여부 및 편의 요청사항:
                        <!-- 교육 신청시, 장애여부 [해당있음]일 경우만 편의 요청사항 요청가능 -->
                        <span  v-if="data.applyType === 1 && data.item.userEdu.isDisorder ===  2">
                          {{ data.item.userEdu.memo }}
                        </span>
                        <span  v-if="data.applyType === 2">{{ data.item.userExam.memo }}</span>
                        <br /><br />
                        (장애 응시 편의사항 요청자는 교육접수 기간 내에 장애인
                        수첩 등 관련 증비서류를 교육 시행기관에 제출해야 하며
                        편의제공 내용이 달라질 수 있음)
                      </p>
                    </div>
                  </div>
                  <div class="row fix70">
                    <div class="cell"><p>수강자 유의사항</p></div>
                  </div>

                  <div class="row">
                    <div class="cell">
                      <p class="left">
                        1. 수강증에 기재된 내용을 반드시 확인하여 교육에 착오가
                        없도록 하시기 바랍니다.<br />
                        <br />
                        2. 명의도용 등 허위기재 시 교육 참가가 불가능할 수
                        있습니다.<br />
                        <br />
                        3. 교육당일에 신분증과 수강증을 지참하셔야 합니다.<br />
                        <br />
                        4. 교육시작 20분전에 도착하시어 자리에 착석하여 주시기
                        바랍니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn bo grey" @click="$emit('eventClose')">
                이전으로
              </button>
              <button class="btn" @click="fnPrint">출력하기</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-edu-application-popup',
  props: {
    data: {
      type: [Array, Object],
      default: () => {}
    },
    callBack: {
      type: [Function]
    }
  },
  methods: {
    dateFormat: function(date) {
      return this.$moment(date).format('YYYY년 MM월 DD일')
    },
    getDate: function(date) {
      const newDate = this.$moment(date)
      const week = ['일', '월', '화', '수', '목', '금', '토']
      const today = newDate.day()
      return week[today]
    },
    fnPrint: function() {
      const html = document.querySelector('html')
      const printContents = document.querySelector('.modal_con').innerHTML
      const printDiv = document.createElement('div')
      printDiv.className = 'print-div'

      html.appendChild(printDiv)
      printDiv.innerHTML = printContents
      document.body.style.display = 'none'
      window.print()
      document.body.style.display = 'block'
      printDiv.style.display = 'none'
    },
  }
}
</script>

<style scoped></style>
